/**
 * Compact read-only chip list. Used on Customers and Vehicles list
 * cards where the tag is informational, not editable. Same chip
 * styling as the editable version so visual identity is consistent.
 *
 * The parent decides which chips to render (e.g. .slice(0, 3) on a
 * dense card) and whether to show an overflow `+N` indicator.
 */

import { cn } from '@/lib/utils'
import { chipClass, chipDotClass } from '@/lib/tag-colors'
import type { Tag } from '@/lib/tags'

export function EditableTagsReadOnly({
  tags,
  className,
  size = 'sm',
}: {
  tags: Tag[]
  className?: string
  size?: 'xs' | 'sm'
}) {
  if (tags.length === 0) return null
  const pad =
    size === 'xs'
      ? 'px-1.5 py-0 text-[10px]'
      : 'px-2 py-0.5 text-xs'
  const dotSize = size === 'xs' ? 'size-1.5' : 'size-2'
  return (
    <div className={cn('flex flex-wrap items-center gap-1', className)}>
      {tags.map((tag) => (
        <span
          key={tag.id}
          className={cn(
            'inline-flex items-center gap-1.5 rounded-md font-medium',
            pad,
            chipClass(tag.color),
          )}
          title={tag.name}
        >
          <span className={cn('inline-block rounded-full', dotSize, chipDotClass(tag.color))} />
          {tag.name}
        </span>
      ))}
    </div>
  )
}
